import React from "react";
import { RiHome2Line } from "react-icons/ri";
import { BiWallet } from "react-icons/bi";
import { CiSettings } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { MdOutlineExitToApp } from "react-icons/md";

function Sidebar() {
  const Navigate = useNavigate();
  const addbusiness = () => {
    Navigate("/business");
  };
  const feed = () => {
    Navigate("/feed");
  };
  const media = () => {
    Navigate("/media");
  };
  const wallet = () => {
    Navigate("/wallet");
  };
  const setting = () => {
    Navigate("/setting");
  };
  const analytics = () => {
    Navigate("/analytics");
  };

  return (
    <>
      <div className="side_main pt-3 ">
        <div className="side_inner" style={{ position: "relative" }}>
          {/* <div className='d-flex justify-content-end '>
                    <MdOutlineExitToApp className='exit_icon'/>
                </div> */}
          <button className="ad_btn mt-2" onClick={addbusiness}>
            Add Business
          </button>
          <div
            className="d-flex gap-3 align-items-center mt-5"
            onClick={() => Navigate("/dashboard")}
          >
            <RiHome2Line className="side_iocn" />
            <p className="side_text">Dashboard</p>
          </div>
          <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={() => Navigate("/profile")}
          >
            <RiHome2Line className="side_iocn" />
            <p className="side_text">Profiles</p>
          </div>
          <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={wallet}
          >
            <BiWallet className="side_iocn" />
            <p className="side_text">Wallet</p>
          </div>
          <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={() => Navigate("/monitor")}
          >
            <BiWallet className="side_iocn" />
            <p className="side_text">Monitor Media</p>
          </div>
          <div className="d-flex gap-3 align-items-center mt-3" onClick={media}>
            <BiWallet className="side_iocn" />
            <p className="side_text">Media Library</p>
          </div>
          {/* <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={() => Navigate("/add-website")}
          >
            <BiWallet className="side_iocn" />
            <p className="side_text">Add Website</p>
          </div> */}
          <div className="d-flex gap-3 align-items-center mt-3"
          onClick={() => Navigate("/analytics")}>
            <BiWallet className="side_iocn" />
            <p className="side_text">Analytics</p>
          </div>
          <div className="d-flex gap-3 align-items-center mt-3" onClick={feed}>
            <BiWallet className="side_iocn" />
            <p className="side_text">Postings</p>
          </div>
          <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={() => Navigate("/listing")}
          >
            <BiWallet className="side_iocn" />
            <p className="side_text">Listings</p>
          </div>
          <div className="d-flex gap-3 align-items-center mt-3" onClick={() => Navigate("/buy&sell")}>
            <BiWallet className="side_iocn" />
            <p className="side_text">Buy & Sell</p>
          </div>
          <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={() => Navigate("/adds")}
          >
            <BiWallet className="side_iocn" />
            <p className="side_text">Banner Ads</p>
          </div>
          <div
            className="d-flex gap-3 align-items-center mt-3"
            onClick={setting}
          >
            <CiSettings className="side_iocn" />
            <p className="side_text">Settings</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
